import React from 'react'
import HeroTerms from './HeroTerms'
import TermsText from './TermsText'

const TermsPage = () => {
  return (
      <>
          <HeroTerms />
          <TermsText/>
      </>
  )
}

export default TermsPage